__turbopack_context__.v({
  "email-signature-squircle": "EmailSignatureSquircle-module-scss-module___edR0q__email-signature-squircle",
});
